const Crown = {
  crownAssessment: "CROWN Assessment",
  humanSkills: "Human Skills",
  cognitiveSkills: "Cognitive Skills",
  workSkills: "Work Skills",
  languageSkills: "Language Skills",
};
export default Crown;
